import axios from "axios";
import API_BASE_URL from "../config/apiConfig";
import { isTokenExpirado } from "./tokenService";
import { recuperarCacheDescriptografado } from "./cacheHandler";
import ApiResponse from "../utils/ApiResponseUtils";
import NotificacaoUtils from "../utils/NotificacaoUtils";
import Mensagens from "../utils/MensagemUtils";

const api = axios.create({
    baseURL: API_BASE_URL,
});

let isLoggingOut = false;

const handleTokenExpired = () => {
    if (isLoggingOut) return Promise.reject(new Error("Logout em andamento"));
    
    isLoggingOut = true;
    
    try {
        return new Promise((resolve) => {
            NotificacaoUtils.info(Mensagens.SESSAO_EXPIRADA, { 
                autoClose: 2500,
                onClose: () => {
                    setTimeout(() => {
                        window.dispatchEvent(new CustomEvent("token-expired"));
                        resolve();
                    }, 100);
                }
            });
        });
    } catch (error) {
        console.error("Erro ao processar logout:", error);
        isLoggingOut = false;
        return Promise.reject(error);
    }
};

api.interceptors.request.use(
    async (configuracao) => {

        if (configuracao.url === '/login_') {
            return configuracao;
        }

        if (isLoggingOut) {
            return Promise.reject(new Error("Logout em andamento"));
        }

        const token = recuperarCacheDescriptografado("access_token");

        if (token) {
            let tokenExpirado = isTokenExpirado(); 

            if (tokenExpirado) {
                await handleTokenExpired();
                return Promise.reject(new Error("Token expirado"));
            } else {
                configuracao.headers.Authorization = `Bearer ${token}`;
            }
        }
        return configuracao;
    },
    (erro) => Promise.reject(new Error(erro))
);

api.interceptors.response.use(
    (response) => {
        if (response.status >= 200 && response.status < 300) {
            return ApiResponse.getDados(response);
        }
        return response;
    },
    (erro) => {
        return Promise.reject(new Error(erro));
    }
);

export const resetLogoutState = () => {
    isLoggingOut = false;
};

export default api;